import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import PrimaryNavigation from '../../components/ui/PrimaryNavigation';
import ContextualBreadcrumb from '../../components/ui/ContextualBreadcrumb';
import FloatingActionButton from '../../components/ui/FloatingActionButton';
import ProjectHeader from './components/ProjectHeader';
import TeamRoster from './components/TeamRoster';
import PhaseTimeline from './components/PhaseTimeline';

const ProjectDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [userRole] = useState('boss');

  // Get projectId from navigation state
  const projectId = location?.state?.projectId;

  // Project database - matches homepage projects
  const projectDatabase = {
    4: {
      id: 4,
      name: "Marina Bay Penthouse",
      estimatedStartDate: "11/28/2025",
      estimatedEndDate: "03/20/2026",
      status: "ongoing",
      completedPhases: 1,
      totalPhases: 12,
      team: [
      {
        id: 1,
        name: "Rachel Kim",
        role: "plumber",
        contact: "rachel.kim@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f6e34819-1763295702221.png",
        avatarAlt: "Professional headshot of Asian woman with shoulder-length black hair in blue work shirt"
      },
      {
        id: 2,
        name: "Marcus Johnson",
        role: "electrical",
        contact: "marcus.johnson@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18c90e628-1763291803636.png",
        avatarAlt: "Professional headshot of African American man with neat hair wearing gray electrician uniform"
      },
      {
        id: 3,
        name: "Tony Chen",
        role: "aircon",
        contact: "tony.chen@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18e347146-1763300910646.png",
        avatarAlt: "Professional headshot of Asian man with glasses wearing blue technician shirt"
      }],

      phases: [
      {
        id: 1,
        name: "Hacking",
        suggestedStartDate: "11/28/2025",
        suggestedEndDate: "12/05/2025",
        actualStartDate: "11/28/2025",
        actualEndDate: "12/04/2025",
        status: "completed",
        assignedTo: [1],
        hasAlert: false
      },
      {
        id: 2,
        name: "3 Musketeers",
        suggestedStartDate: "12/06/2025",
        suggestedEndDate: "12/20/2025",
        actualStartDate: "12/06/2025",
        actualEndDate: "",
        status: "in_progress",
        assignedTo: [1, 2, 3],
        hasAlert: false,
        tradeProgress: {
          plumber: 68,
          electrical: 68,
          aircon: 68
        }
      },
      {
        id: 3,
        name: "False Ceiling",
        suggestedStartDate: "12/21/2025",
        suggestedEndDate: "01/05/2026",
        actualStartDate: "",
        actualEndDate: "",
        status: "pending",
        assignedTo: [],
        hasAlert: false
      }]

    },
    5: {
      id: 5,
      name: "Orchard Road Retail Space",
      estimatedStartDate: "11/22/2025",
      estimatedEndDate: "02/15/2026",
      status: "ongoing",
      completedPhases: 2,
      totalPhases: 12,
      team: [
      {
        id: 1,
        name: "Sophie Turner",
        role: "painter",
        contact: "sophie.turner@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_103b528db-1763293982935.png",
        avatarAlt: "Professional headshot of young woman with brown hair in white painter coveralls"
      },
      {
        id: 2,
        name: "Andrew Mitchell",
        role: "carpenter",
        contact: "andrew.mitchell@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_179ebd6f2-1763294255544.png",
        avatarAlt: "Professional headshot of middle-aged man with salt and pepper beard wearing brown work shirt"
      },
      {
        id: 3,
        name: "Linda Wong",
        role: "main-con",
        contact: "linda.wong@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1dfc93ba3-1763295185909.png",
        avatarAlt: "Professional headshot of Asian woman with short hair wearing orange safety vest"
      }],

      phases: [
      {
        id: 1,
        name: "Hacking",
        suggestedStartDate: "11/22/2025",
        suggestedEndDate: "11/29/2025",
        actualStartDate: "11/22/2025",
        actualEndDate: "11/28/2025",
        status: "completed",
        assignedTo: [3],
        hasAlert: false
      },
      {
        id: 2,
        name: "3 Musketeers",
        suggestedStartDate: "11/30/2025",
        suggestedEndDate: "12/14/2025",
        actualStartDate: "11/30/2025",
        actualEndDate: "12/13/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 3,
        name: "Painting",
        suggestedStartDate: "12/15/2025",
        suggestedEndDate: "01/05/2026",
        actualStartDate: "12/15/2025",
        actualEndDate: "",
        status: "in_progress",
        assignedTo: [1],
        hasAlert: true
      }]

    },
    6: {
      id: 6,
      name: "Sentosa Resort Villa",
      estimatedStartDate: "12/01/2025",
      estimatedEndDate: "04/30/2026",
      status: "ongoing",
      completedPhases: 0,
      totalPhases: 12,
      team: [
      {
        id: 1,
        name: "Carlos Rodriguez",
        role: "carpenter",
        contact: "carlos.rodriguez@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10cbc5b27-1763293994568.png",
        avatarAlt: "Professional headshot of Hispanic man with short dark hair wearing brown carpenter apron"
      },
      {
        id: 2,
        name: "Jessica Park",
        role: "main-con",
        contact: "jessica.park@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_150830479-1763297572906.png",
        avatarAlt: "Professional headshot of Korean woman with long dark hair in white work shirt"
      }],

      phases: [
      {
        id: 1,
        name: "Carpentry Measurement",
        suggestedStartDate: "12/01/2025",
        suggestedEndDate: "12/08/2025",
        actualStartDate: "12/01/2025",
        actualEndDate: "",
        status: "in_progress",
        assignedTo: [1],
        hasAlert: false
      }]

    },
    7: {
      id: 7,
      name: "Bukit Timah Bungalow",
      estimatedStartDate: "11/18/2025",
      estimatedEndDate: "03/25/2026",
      status: "ongoing",
      completedPhases: 1,
      totalPhases: 12,
      team: [
      {
        id: 1,
        name: "David Tan",
        role: "plumber",
        contact: "david.tan@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_18142c6fb-1763296479151.png",
        avatarAlt: "Professional headshot of Asian man with short black hair wearing blue plumber coveralls"
      },
      {
        id: 2,
        name: "Maria Santos",
        role: "hacker",
        contact: "maria.santos@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1bf7b3550-1763298177227.png",
        avatarAlt: "Professional headshot of Filipino woman with long hair in white work shirt"
      },
      {
        id: 3,
        name: "Tom Harrison",
        role: "electrical",
        contact: "tom.harrison@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_106f79f20-1763295098523.png",
        avatarAlt: "Professional headshot of older Caucasian man with gray hair wearing blue electrician uniform"
      }],

      phases: [
      {
        id: 1,
        name: "Hacking",
        suggestedStartDate: "11/18/2025",
        suggestedEndDate: "11/25/2025",
        actualStartDate: "11/18/2025",
        actualEndDate: "11/24/2025",
        status: "completed",
        assignedTo: [2],
        hasAlert: false
      },
      {
        id: 2,
        name: "Plumbing",
        suggestedStartDate: "11/26/2025",
        suggestedEndDate: "12/10/2025",
        actualStartDate: "11/26/2025",
        actualEndDate: "",
        status: "in_progress",
        assignedTo: [1],
        hasAlert: true
      }]

    },
    8: {
      id: 8,
      name: "East Coast Shophouse",
      estimatedStartDate: "11/12/2025",
      estimatedEndDate: "02/20/2026",
      status: "ongoing",
      completedPhases: 3,
      totalPhases: 12,
      team: [
      {
        id: 1,
        name: "Kevin Lim",
        role: "aircon",
        contact: "kevin.lim@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c7be1399-1763300910183.png",
        avatarAlt: "Professional headshot of Asian man with glasses and short hair in blue technician uniform"
      },
      {
        id: 2,
        name: "Sandra Martinez",
        role: "electrical",
        contact: "sandra.martinez@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1abb32fe9-1763298504398.png",
        avatarAlt: "Professional headshot of Hispanic woman with curly hair in gray work shirt"
      }],

      phases: [
      {
        id: 1,
        name: "Hacking",
        suggestedStartDate: "11/12/2025",
        suggestedEndDate: "11/19/2025",
        actualStartDate: "11/12/2025",
        actualEndDate: "11/18/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 2,
        name: "3 Musketeers",
        suggestedStartDate: "11/20/2025",
        suggestedEndDate: "12/04/2025",
        actualStartDate: "11/20/2025",
        actualEndDate: "12/03/2025",
        status: "completed",
        assignedTo: [2],
        hasAlert: false
      },
      {
        id: 3,
        name: "False Ceiling",
        suggestedStartDate: "12/05/2025",
        suggestedEndDate: "12/19/2025",
        actualStartDate: "12/05/2025",
        actualEndDate: "12/18/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 4,
        name: "Aircon Installation",
        suggestedStartDate: "12/20/2025",
        suggestedEndDate: "01/10/2026",
        actualStartDate: "12/20/2025",
        actualEndDate: "",
        status: "in_progress",
        assignedTo: [1],
        hasAlert: true
      }]

    },
    9: {
      id: 9,
      name: "Jurong West HDB Block",
      estimatedStartDate: "11/30/2025",
      estimatedEndDate: "01/31/2026",
      status: "ongoing",
      completedPhases: 10,
      totalPhases: 12,
      team: [
      {
        id: 1,
        name: "Amy Ng",
        role: "cleaner",
        contact: "amy.ng@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16328f620-1763294671537.png",
        avatarAlt: "Professional headshot of Asian woman with tied-back hair in yellow cleaning uniform"
      },
      {
        id: 2,
        name: "Hassan Ibrahim",
        role: "painter",
        contact: "hassan.ibrahim@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c2f96239-1763296912126.png",
        avatarAlt: "Professional headshot of Middle Eastern man with mustache in white painter uniform"
      }],

      phases: [
      {
        id: 1,
        name: "Hacking",
        suggestedStartDate: "11/30/2025",
        suggestedEndDate: "12/02/2025",
        actualStartDate: "11/30/2025",
        actualEndDate: "12/01/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 2,
        name: "Painting",
        suggestedStartDate: "12/03/2025",
        suggestedEndDate: "12/17/2025",
        actualStartDate: "12/03/2025",
        actualEndDate: "12/16/2025",
        status: "completed",
        assignedTo: [2],
        hasAlert: false
      },
      {
        id: 3,
        name: "Cleaning",
        suggestedStartDate: "12/18/2025",
        suggestedEndDate: "12/25/2025",
        actualStartDate: "12/18/2025",
        actualEndDate: "",
        status: "in_progress",
        assignedTo: [1],
        hasAlert: false
      }]

    },
    10: {
      id: 10,
      name: "Dempsey Hill Restaurant",
      estimatedStartDate: "11/10/2025",
      estimatedEndDate: "01/15/2026",
      status: "ongoing",
      completedPhases: 4,
      totalPhases: 12,
      team: [
      {
        id: 1,
        name: "Ryan Thompson",
        role: "electrical",
        contact: "ryan.thompson@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_177e4f743-1763293085231.png",
        avatarAlt: "Professional headshot of Caucasian man with short blonde hair in gray electrician polo"
      },
      {
        id: 2,
        name: "Priya Sharma",
        role: "main-con",
        contact: "priya.sharma@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1c21fb188-1763301095388.png",
        avatarAlt: "Professional headshot of Indian woman with long dark hair in orange safety vest"
      },
      {
        id: 3,
        name: "Jack Liu",
        role: "carpenter",
        contact: "jack.liu@email.com",
        status: "active",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b41c284a-1763295621343.png",
        avatarAlt: "Professional headshot of Asian man with short hair wearing brown carpenter vest"
      }],

      phases: [
      {
        id: 1,
        name: "Hacking",
        suggestedStartDate: "11/10/2025",
        suggestedEndDate: "11/17/2025",
        actualStartDate: "11/10/2025",
        actualEndDate: "11/16/2025",
        status: "completed",
        assignedTo: [2],
        hasAlert: false
      },
      {
        id: 2,
        name: "3 Musketeers",
        suggestedStartDate: "11/18/2025",
        suggestedEndDate: "12/02/2025",
        actualStartDate: "11/18/2025",
        actualEndDate: "12/01/2025",
        status: "completed",
        assignedTo: [1],
        hasAlert: false
      },
      {
        id: 3,
        name: "False Ceiling",
        suggestedStartDate: "12/03/2025",
        suggestedEndDate: "12/17/2025",
        actualStartDate: "12/03/2025",
        actualEndDate: "12/16/2025",
        status: "completed",
        assignedTo: [3],
        hasAlert: false
      },
      {
        id: 4,
        name: "Carpentry Installation",
        suggestedStartDate: "12/18/2025",
        suggestedEndDate: "12/28/2025",
        actualStartDate: "12/18/2025",
        actualEndDate: "12/27/2025",
        status: "completed",
        assignedTo: [3],
        hasAlert: false
      },
      {
        id: 5,
        name: "Electrical",
        suggestedStartDate: "12/29/2025",
        suggestedEndDate: "01/10/2026",
        actualStartDate: "12/29/2025",
        actualEndDate: "",
        status: "in_progress",
        assignedTo: [1],
        hasAlert: true
      }]

    },
    15: {
      id: 15,
      name: "Clementi Avenue Condo",
      estimatedStartDate: "08/15/2025",
      estimatedEndDate: "11/20/2025",
      status: "completed",
      completedPhases: 12,
      totalPhases: 12,
      team: [
      {
        id: 1,
        name: "Peter Nguyen",
        role: "hacker",
        contact: "peter.nguyen@email.com",
        status: "completed",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1f1d7c541-1763295204287.png",
        avatarAlt: "Professional headshot of Vietnamese man with short black hair wearing navy blue work shirt"
      },
      {
        id: 2,
        name: "Olivia Chen",
        role: "plumber",
        contact: "olivia.chen@email.com",
        status: "completed",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_10d60e496-1763295319842.png",
        avatarAlt: "Professional headshot of Asian woman with long black hair in white collared shirt"
      },
      {
        id: 3,
        name: "Mohammed Ali",
        role: "false-ceiling",
        contact: "mohammed.ali@email.com",
        status: "completed",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1df7140a9-1763300518012.png",
        avatarAlt: "Professional headshot of Middle Eastern man with brown hair wearing orange safety vest"
      }],

      phases: [
      {
        id: 1,
        name: "Hacking",
        suggestedStartDate: "08/15/2025",
        suggestedEndDate: "08/22/2025",
        actualStartDate: "08/15/2025",
        actualEndDate: "08/21/2025",
        status: "completed",
        assignedTo: [1],
        hasAlert: false
      },
      {
        id: 2,
        name: "3 Musketeers",
        suggestedStartDate: "08/23/2025",
        suggestedEndDate: "09/06/2025",
        actualStartDate: "08/23/2025",
        actualEndDate: "09/05/2025",
        status: "completed",
        assignedTo: [2],
        hasAlert: false
      },
      {
        id: 3,
        name: "False Ceiling",
        suggestedStartDate: "09/07/2025",
        suggestedEndDate: "09/21/2025",
        actualStartDate: "09/07/2025",
        actualEndDate: "09/20/2025",
        status: "completed",
        assignedTo: [3],
        hasAlert: false
      },
      {
        id: 4,
        name: "Tiling",
        suggestedStartDate: "09/22/2025",
        suggestedEndDate: "10/06/2025",
        actualStartDate: "09/22/2025",
        actualEndDate: "10/05/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 5,
        name: "Carpentry Measurement",
        suggestedStartDate: "10/07/2025",
        suggestedEndDate: "10/14/2025",
        actualStartDate: "10/07/2025",
        actualEndDate: "10/13/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 6,
        name: "Carpentry Installation",
        suggestedStartDate: "10/15/2025",
        suggestedEndDate: "10/28/2025",
        actualStartDate: "10/15/2025",
        actualEndDate: "10/27/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 7,
        name: "Painting",
        suggestedStartDate: "10/29/2025",
        suggestedEndDate: "11/08/2025",
        actualStartDate: "10/29/2025",
        actualEndDate: "11/07/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 8,
        name: "Aircon Installation",
        suggestedStartDate: "11/09/2025",
        suggestedEndDate: "11/15/2025",
        actualStartDate: "11/09/2025",
        actualEndDate: "11/14/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 9,
        name: "Cleaning",
        suggestedStartDate: "11/16/2025",
        suggestedEndDate: "11/20/2025",
        actualStartDate: "11/16/2025",
        actualEndDate: "11/20/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      }]

    },
    16: {
      id: 16,
      name: "Raffles Place Office Tower",
      estimatedStartDate: "07/01/2025",
      estimatedEndDate: "11/25/2025",
      status: "completed",
      completedPhases: 12,
      totalPhases: 12,
      team: [
      {
        id: 1,
        name: "Jonathan Ong",
        role: "main-con",
        contact: "jonathan.ong@email.com",
        status: "completed",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b41c284a-1763295621343.png",
        avatarAlt: "Professional headshot of Asian man with gray hair wearing yellow hard hat"
      },
      {
        id: 2,
        name: "Victoria James",
        role: "carpenter",
        contact: "victoria.james@email.com",
        status: "completed",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_128f7e26a-1763297659639.png",
        avatarAlt: "Professional headshot of Caucasian woman with curly brown hair wearing brown work apron"
      },
      {
        id: 3,
        name: "Henry Goh",
        role: "painter",
        contact: "henry.goh@email.com",
        status: "completed",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_121becfdf-1763292584681.png",
        avatarAlt: "Professional headshot of Asian man with mustache in white painter uniform"
      },
      {
        id: 4,
        name: "Isabella Santos",
        role: "cleaner",
        contact: "isabella.santos@email.com",
        status: "completed",
        avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_16328f620-1763294671537.png",
        avatarAlt: "Professional headshot of Filipino woman with brown hair in yellow cleaning uniform"
      }],

      phases: [
      {
        id: 1,
        name: "Hacking",
        suggestedStartDate: "07/01/2025",
        suggestedEndDate: "07/10/2025",
        actualStartDate: "07/01/2025",
        actualEndDate: "07/09/2025",
        status: "completed",
        assignedTo: [1],
        hasAlert: false
      },
      {
        id: 2,
        name: "3 Musketeers",
        suggestedStartDate: "07/11/2025",
        suggestedEndDate: "07/28/2025",
        actualStartDate: "07/11/2025",
        actualEndDate: "07/27/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 3,
        name: "False Ceiling",
        suggestedStartDate: "07/29/2025",
        suggestedEndDate: "08/15/2025",
        actualStartDate: "07/29/2025",
        actualEndDate: "08/14/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 4,
        name: "Tiling",
        suggestedStartDate: "08/16/2025",
        suggestedEndDate: "09/02/2025",
        actualStartDate: "08/16/2025",
        actualEndDate: "09/01/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 5,
        name: "Carpentry Measurement",
        suggestedStartDate: "09/03/2025",
        suggestedEndDate: "09/12/2025",
        actualStartDate: "09/03/2025",
        actualEndDate: "09/11/2025",
        status: "completed",
        assignedTo: [2],
        hasAlert: false
      },
      {
        id: 6,
        name: "Carpentry Installation",
        suggestedStartDate: "09/13/2025",
        suggestedEndDate: "09/30/2025",
        actualStartDate: "09/13/2025",
        actualEndDate: "09/29/2025",
        status: "completed",
        assignedTo: [2],
        hasAlert: false
      },
      {
        id: 7,
        name: "Painting",
        suggestedStartDate: "10/01/2025",
        suggestedEndDate: "10/18/2025",
        actualStartDate: "10/01/2025",
        actualEndDate: "10/17/2025",
        status: "completed",
        assignedTo: [3],
        hasAlert: false
      },
      {
        id: 8,
        name: "Aircon Installation",
        suggestedStartDate: "10/19/2025",
        suggestedEndDate: "10/30/2025",
        actualStartDate: "10/19/2025",
        actualEndDate: "10/29/2025",
        status: "completed",
        assignedTo: [],
        hasAlert: false
      },
      {
        id: 9,
        name: "Cleaning",
        suggestedStartDate: "10/31/2025",
        suggestedEndDate: "11/10/2025",
        actualStartDate: "10/31/2025",
        actualEndDate: "11/09/2025",
        status: "completed",
        assignedTo: [4],
        hasAlert: false
      },
      {
        id: 10,
        name: "Final Inspection",
        suggestedStartDate: "11/11/2025",
        suggestedEndDate: "11/15/2025",
        actualStartDate: "11/11/2025",
        actualEndDate: "11/14/2025",
        status: "completed",
        assignedTo: [1],
        hasAlert: false
      },
      {
        id: 11,
        name: "Touch-ups",
        suggestedStartDate: "11/16/2025",
        suggestedEndDate: "11/22/2025",
        actualStartDate: "11/16/2025",
        actualEndDate: "11/21/2025",
        status: "completed",
        assignedTo: [3],
        hasAlert: false
      },
      {
        id: 12,
        name: "Handover",
        suggestedStartDate: "11/23/2025",
        suggestedEndDate: "11/25/2025",
        actualStartDate: "11/23/2025",
        actualEndDate: "11/25/2025",
        status: "completed",
        assignedTo: [1],
        hasAlert: false
      }]

    }
  };

  // Get the project data based on projectId
  const projectData = projectId ? projectDatabase?.[projectId] : null;

  const [project, setProject] = useState(projectData || {
    id: null,
    name: "Project Not Found",
    estimatedStartDate: "N/A",
    estimatedEndDate: "N/A",
    status: "N/A",
    completedPhases: 0,
    totalPhases: 0
  });

  const [team, setTeam] = useState(projectData?.team || []);
  const [phases, setPhases] = useState(projectData?.phases || []);

  useEffect(() => {
    window.scrollTo(0, 0);

    // If no projectId or project not found, redirect to homepage
    if (!projectId || !projectData) {
      console.warn('Project not found, redirecting to homepage');
      navigate('/');
    }
  }, [projectId, projectData, navigate]);

  const handleUpdateProject = (updatedProject) => {
    setProject(updatedProject);
  };

  const handleUpdateTeam = (updatedTeam) => {
    setTeam(updatedTeam);
  };

  const handleUpdatePhase = (updatedPhase) => {
    setPhases(phases?.map((phase) =>
    phase?.id === updatedPhase?.id ? updatedPhase : phase
    ));

    const completedCount = phases?.filter((p) =>
    p?.id === updatedPhase?.id ? updatedPhase?.status === 'completed' : p?.status === 'completed'
    )?.length;

    setProject({
      ...project,
      completedPhases: completedCount
    });
  };

  const handleNavigateToPhase = (phaseId) => {
    const phase = phases?.find((p) => p?.id === phaseId);
    navigate('/phase-management', {
      state: {
        phaseId,
        projectId: project?.id,
        projectName: project?.name,
        phase: phase
      }
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <PrimaryNavigation />
      <ContextualBreadcrumb />
      
      <main className="main-content-mobile-nav">
        <ProjectHeader
          project={project}
          onUpdate={handleUpdateProject}
          userRole={userRole}
          navigate={navigate} />


        <TeamRoster
          team={team}
          onUpdate={handleUpdateTeam}
          userRole={userRole} />


        <PhaseTimeline
          phases={phases}
          team={team}
          onUpdatePhase={handleUpdatePhase}
          userRole={userRole}
          onNavigateToPhase={handleNavigateToPhase} />

      </main>

      <FloatingActionButton userRole={userRole} />
    </div>);

};

export default ProjectDetails;